export const DecimalPlacesOption = [
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5", label: "5" },
];

export const FIELD_TYPE = {
  LABEL: "Label",
  TOGGLE: "Toggle",
  INPUT_RADIO: "Input Radio",
  INPUT_DROPDOWN: "Input Dropdown",
  INPUT_TEXT: "Input Text",
  INPUT_NUMBER: "Input Number",
  INPUT_EMAIL: "Input Email",
  INPUT_CURRENT_TIME: "Input Current Time",
  INPUT_DATE: "Input Date",
  INPUT_DATE_AND_TIME: "Input Date and Time",
  LINKED_FIELD: "Linked Field",
  HYPERLINK: "Hyperlink",
  BARCODE: "Barcode",
  FILE_UPLOAD: "File Upload",
  CALCULATION: "Calculation",
  IMAGE_UPLOAD: "Image Upload",
};

export const VisualDisplay = [
  { value: "none", label: "None" },
  { value: "above", label: "Above" },
  { value: "below", label: "Below" },
  { value: "both", label: "Both above and below" },
];

export const LayoutOption = [
  { value: 12, label: "Full Layout" },
  { value: 6, label: "Row Layout of 2 Inputs" },
  { value: 4, label: "Row Layout of 3 Inputs" },
  { value: 3, label: "Row Layout of 4 Inputs" },
];

export const TimeFormat = [
  { value: "hh:mm A", label: "12 hour" },
  { value: "HH:mm", label: "24 hour" },
];

export const TimeFormatDisplay = [
  { value: "HH :MM :SS", label: "HH:MM:SS" },
  { value: "[HH]:[MM]:[SS]", label: "[HH]:[MM]:[SS]" },
];

export const BarCodeOption = [
  { value: "UPC", label: "UPC" },
  { value: "EAN", label: "EAN" },
  { value: "Code 128", label: "Code 128" },
  { value: "Code 39", label: "Code 39" },
  { value: "PDF417", label: "PDF417" },
];

export const DateFormat = [
  { value: "DD:MM:YY", label: "DD:MM:YY" },
  { value: "DD/MM/YY", label: "DD/MM/YY" },
  { value: "DD-MM-YY", label: "DD-MM-YY" },
];
export const FileSize=[
  {value:"Bytes",label:"Bytes"},
  {value:"Kilobytes (KB)",label:"Kilobytes (KB)"},
  {value:"Megabytes (MB)",label:"Megabytes (MB)"},
]
export const MultiUploadOptions = [
  { value:2, label:2 },
  { value:3, label:3 },
  { value:4, label:4 },
  { value:5, label:5 },
];
export const TABS = {
  GENERAL: "General",
  NOTE: "Note",
  VALIDATIONS: "Validations",
  LABEL: "Label",
  TOGGLE: "Toggle",
  INPUT_RADIO: "Input Radio",
  INPUT_DROPDOWN: "Input Dropdown",
  INPUT_TEXT: "Input Text",
  INPUT_NUMBER: "Input Number",
  STATIC_NUMBER: "Static Number",
  INPUT_EMAIL: "Input Email",
  INPUT_CURRENT_TIME: "Input Current Time",
  INPUT_DATE: "Input Date",
  INPUT_DATE_AND_TIME: "Input Date and Time",
  LINKED_FIELD: "Linked Field",
  HYPERLINK: "Hyperlink",
  BARCODE: "Barcode",
  FILE_UPLOAD: "File Upload",
  CALCULATION: "Calculation",
  FORMULA_VARIABLES: "Formula Variables",
  CONDITION: "Condition",
  IMAGE_UPLOAD: "Image Upload",
};

export const TabPresetMap = {
  [FIELD_TYPE.LABEL]: [TABS.GENERAL, TABS.NOTE],
  [FIELD_TYPE.TOGGLE]: [TABS.GENERAL, TABS.TOGGLE, TABS.NOTE, TABS.VALIDATIONS],
  [FIELD_TYPE.INPUT_TEXT]: [
    TABS.GENERAL,
    TABS.INPUT_TEXT,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_RADIO]: [
    TABS.GENERAL,
    TABS.INPUT_RADIO,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.CONDITION,
  ],
  [FIELD_TYPE.INPUT_DROPDOWN]: [
    TABS.GENERAL,
    TABS.INPUT_DROPDOWN,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.CONDITION,
  ],
  [FIELD_TYPE.INPUT_NUMBER]: [
    TABS.GENERAL,
    TABS.INPUT_NUMBER,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_EMAIL]: [
    TABS.GENERAL,
    TABS.INPUT_EMAIL,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_CURRENT_TIME]: [
    TABS.GENERAL,
    TABS.INPUT_CURRENT_TIME,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_DATE]: [
    TABS.GENERAL,
    TABS.INPUT_DATE,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.INPUT_DATE_AND_TIME]: [
    TABS.GENERAL,
    TABS.INPUT_DATE_AND_TIME,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.LINKED_FIELD]: [
    TABS.GENERAL,
    TABS.LINKED_FIELD,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.HYPERLINK]: [
    TABS.GENERAL,
    TABS.HYPERLINK,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.BARCODE]: [TABS.GENERAL, TABS.NOTE],
  [FIELD_TYPE.FILE_UPLOAD]: [
    TABS.GENERAL,
    TABS.FILE_UPLOAD,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.CALCULATION]: [
    TABS.GENERAL,
    TABS.FORMULA_VARIABLES,
    TABS.CALCULATION,
    TABS.NOTE,
    TABS.VALIDATIONS,
  ],
  [FIELD_TYPE.IMAGE_UPLOAD]: [
    TABS.GENERAL,
    TABS.NOTE,
    TABS.VALIDATIONS,
    TABS.IMAGE_UPLOAD,
  ],
};
